import axios from "axios";
import { logout, getAuthData, updateToken, isTokenExpired } from "./service";

const axiosClient = axios.create();

axiosClient.interceptors.request.use(
  async (config) => {
    try {
      // eslint-disable-next-line prefer-const
      let { accessToken, refreshToken } = getAuthData();
      if (!refreshToken) throw new Error("No refresh token exists.");

      if (!accessToken) {
        // Retrieve a fresh access token via the API and updates the services store
        accessToken = await updateToken();
      }

      if (isTokenExpired(accessToken)) {
        console.log("Token expired... refreshing tokens");
        // Retrieve a fresh access token via the API and updates the services store
        accessToken = await updateToken();
      }

      if (config && config.headers) {
        config.headers["x-jwt-token"] = `${accessToken}`;
      }
    } catch (error) {
      console.error(error);

      logout();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && [401, 403].includes(error.response.status)) {
      console.error("Unauthorized request");
      logout();
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
